<template>
    <div class="fixed z-40 inset-0 drop-shadow-3xl transition-opacity bg-gray-500 bg-opacity-70" :class="{'bg-gray-500 bg-opacity-70': backdrop, 'hidden': !visible}">
        <div class="flex items-center justify-center h-screen p-4 overflow-y-auto">
            <div class="lds-next bg-transparent">
                <div class="border-white border"></div>
                <div class="border-white border"></div>
                <div class="border-white border"></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'Loading',
    props: {
        backdrop: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        }
    }
})
export default class Loading extends Vue {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
